function pickPropping() {
  //BROR articles does not have propping
  return;
}
export default { pickPropping };
